import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Box, Inline, Stack, xcss } from '@atlaskit/primitives';
import { components } from '@atlaskit/select';
import React from 'react';
import { charlieTextFontFamily } from '../../../FontFamily';
const optionWrapperStyles = xcss({
  // Enable wrapping text within the option container
  whiteSpace: 'normal'
});
const optionStyles = xcss(_objectSpread({}, charlieTextFontFamily));
export const CustomOptionInternal = _ref => {
  let {
    label
  } = _ref;
  return /*#__PURE__*/React.createElement(Inline, {
    space: "space.100",
    alignBlock: "center",
    grow: "fill",
    xcss: optionWrapperStyles
  }, /*#__PURE__*/React.createElement(Stack, null, /*#__PURE__*/React.createElement(Box, {
    xcss: optionStyles
  }, label)));
};
export const CustomOption = props => /*#__PURE__*/React.createElement(components.Option, props, /*#__PURE__*/React.createElement(CustomOptionInternal, props.data));